import { useEffect, useState } from "react"

interface VisualViewportBounds {
  height: string
  offsetTop: string
}

// iOS/iPadOS Safari resolves `100vh`/`h-screen` to the large viewport (chrome
// collapsed), so a full-height shell extends its bottom edge — and any
// bottom-anchored action row — beneath the browser toolbar and off-screen. The
// software keyboard shrinks the visible area further with no effect on `100vh`.
// `window.visualViewport.height` reports the actually-visible height and shrinks
// for both browser chrome and the keyboard. Its offset keeps the shell aligned
// when Safari pans the visual viewport toward a focused field. Falls back to
// `100dvh` at the layout viewport origin when the API is unavailable.
export function useVisualViewportBounds(): VisualViewportBounds {
  const [bounds, setBounds] = useState<VisualViewportBounds>({ height: "100dvh", offsetTop: "0px" })

  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return

    const apply = () => setBounds({ height: `${viewport.height}px`, offsetTop: `${viewport.offsetTop}px` })
    apply()

    viewport.addEventListener("resize", apply)
    viewport.addEventListener("scroll", apply)
    return () => {
      viewport.removeEventListener("resize", apply)
      viewport.removeEventListener("scroll", apply)
    }
  }, [])

  return bounds
}
